import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";

/**
 * Configuration for activity card detail card spacing.
 * The topMargin value determines the negative margin for the detail card,
 * and the bottomPadding is calculated to maintain proper spacing.
 *
 * Formula: bottomPadding = abs(topMargin) + 16px gap
 */
export const ACTIVITY_CARD_SPACING = {
  [SPIFF_RULE_EVENTS.signup]: {
    topMargin: "-mt-10", // 40px
    bottomPadding: "pb-[56px]", // 40px + 16px = 56px
  },
  [SPIFF_RULE_EVENTS.referral_creation]: {
    topMargin: "-mt-14", // 56px
    bottomPadding: "pb-[72px]", // 56px + 16px = 72px
  },
  [SPIFF_RULE_EVENTS.referral_completion]: {
    topMargin: "-mt-16", // 64px
    bottomPadding: "pb-[80px]", // 64px + 16px = 80px
  },
  [SPIFF_RULE_EVENTS.five_star_review]: {
    topMargin: "-mt-14", // 56px
    bottomPadding: "pb-[72px]", // 56px + 16px = 72px
  },
  [SPIFF_RULE_EVENTS.yard_sign_photo]: {
    topMargin: "-mt-28", // 112px
    bottomPadding: "pb-[128px]", // 112px + 16px = 128px
  },
  [SPIFF_RULE_EVENTS.pricebook_item_sale]: {
    topMargin: "-mt-10", // 40px
    bottomPadding: "pb-[56px]", // 40px + 16px = 56px
  },
  [SPIFF_RULE_EVENTS.tech_generated_lead]: {
    topMargin: "-mt-10", // 40px
    bottomPadding: "", // no detail card
  },
  [SPIFF_RULE_EVENTS.driving_score]: {
    topMargin: "-mt-10", // 40px
    bottomPadding: "", // no detail card
  },
} as const;

// Extract just the top margins for use in detail cards
export const DETAIL_CARD_TOP_MARGIN = Object.entries(
  ACTIVITY_CARD_SPACING,
).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key]: value.topMargin,
  }),
  {} as Record<string, string>,
);

// Extract just the bottom padding for use in activity items
export const ACTIVITY_CARD_BOTTOM_PADDING = Object.entries(
  ACTIVITY_CARD_SPACING,
).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key]: value.bottomPadding,
  }),
  {} as Record<string, string>,
);
